import { Component } from 'opus-angular-seed-core';
import { UPLOAD_STATUS } from '../../../services/uploadProgress';
import { formatFileSize } from '../../file/fileConstants';

@Component({
    template: `
    <div class="upload-progress" ng-if="vm.UploadProgressService.uploads.length">
        <div
            class="upload-progress__item"
            ng-repeat="upload in vm.UploadProgressService.uploads track by upload.id"
            ng-class="{
                'upload-progress__item--done': vm.isDone(upload),
                'upload-progress__item--error': vm.isError(upload),
                'upload-progress__item--leaving': upload.isLeaving
            }"
        >
            <div class="upload-progress__head">
                <span class="upload-progress__name" title="{{ upload.name }}">{{ upload.name }}</span>
                <button
                    type="button"
                    class="upload-progress__close"
                    ng-click="vm.dismiss(upload)"
                    title="{{ 'upload.Dismiss' | translate }}"
                >&times;</button>
            </div>
            <p class="upload-progress__meta">{{ vm.getStatusText(upload) }}</p>
            <div class="upload-progress__track" ng-if="!vm.isError(upload)">
                <span ng-style="{ width: upload.progress + '%' }"></span>
            </div>
        </div>
    </div>
    `
})
export default class {
    constructor (UploadProgressService, $translate) {
        this.UploadProgressService = UploadProgressService;
        this.$translate = $translate;
    }

    isDone (upload) {
        return upload.status === UPLOAD_STATUS.DONE;
    }

    isError (upload) {
        return upload.status === UPLOAD_STATUS.ERROR;
    }

    /**
     * The line under the file name: the reason it failed, or how far it got. The
     * size stays on screen once the upload is done, so the card still says what
     * went through. An upload of unknown size has no counter to show, only that
     * it is running.
     */
    getStatusText (upload) {
        if (this.isError(upload)) {
            return upload.error || this.$translate.instant('upload.Upload failed');
        }

        if (this.isDone(upload)) {
            const done = this.$translate.instant('upload.Upload complete');

            return upload.size ? `${formatFileSize(upload.size)} · ${done}` : done;
        }

        if (!upload.size) {
            return this.$translate.instant('upload.Uploading');
        }

        return `${formatFileSize(upload.loaded)} / ${formatFileSize(upload.size)} · ${upload.progress}%`;
    }

    dismiss (upload) {
        this.UploadProgressService.dismiss(upload);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/upload/progress/index.js